import SmallWidgetIndicator from './component'

export default SmallWidgetIndicator
